import { MATERIAL_TYPE_ID, MATERIAL_TYPE } from '@/components/material-selector/consts.js'

/**
 * @description:  根据素材类型，获取对应的常用尺寸
 * @return {*}
 */
const sizes = [{ label: '1280*720' }, { label: '720*1280' }, { label: '1920*1080' }, { label: '1080*1920' }, { label: '456*300' }]
export const MATERIAL_TYPE_SIZES = {
  [MATERIAL_TYPE_ID[MATERIAL_TYPE.VIDEO]]: sizes,
  [MATERIAL_TYPE_ID[MATERIAL_TYPE.IMAGE]]: sizes,
  [MATERIAL_TYPE_ID[MATERIAL_TYPE.POSTER]]: [],
  [MATERIAL_TYPE_ID[MATERIAL_TYPE.LOGO]]: [{ label: '108*108' }]
}
